import React from "react";
import styles from "./AboutMeSection.module.css";
import { Button } from "../Buttons/Button/Button";
import paws from "../assets/paws.svg";
import photo from "../assets/photos/aboutMe.jpeg";

function AboutMeSection({ setShowAboutMe, setHidden }) {
  function onClick() {
    setHidden(true);
    setShowAboutMe(true);
  }
  return (
    <div id="about_me_section" className={styles.container}>
      <h2 className={styles.title}>Sobre Mí</h2>
      <img className={styles.photo} src={photo} alt="Una foto mía."></img>
      <img src={paws} alt="paws" className={styles.paws}></img>
      <div className={styles.text}>
        <h3 className={styles.subtitle}>¡Hola! Soy Guadalupe</h3>
        <p>
          Soy una argentina viviendo en España. Comencé Paw Paw Needle con mas
          dudas que certezas, con mucho por aprender pero feliz de haber dado
          los primeros pasos para que este pequeño proyecto crezca cada vez más.{" "}
        </p>
        <Button onClick={onClick}>Leer más</Button>
      </div>
    </div>
  );
}

export { AboutMeSection };
